module.exports = __webpack_public_path__ + "static/2017-aeta-outreach5-c2c4a37555794e7225fcd3f35cb940c0.jpg";